module.exports = __webpack_public_path__ + "themes/mf/img/background@2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/background@2x.jpg
// module id = 68
// module chunks = 3